import React from 'react'
import { Link } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'

export default function SupportNoticesPage() {
  return (
    <MarketingSiteLayout>
      <div className="mx-auto max-w-3xl px-4 py-14 md:py-20">
        <nav className="text-sm text-slate-500">
          <Link to="/support" className="hover:text-brand-navy">
            고객센터
          </Link>
          <span className="mx-2">/</span>
          <span className="text-slate-800">공지사항</span>
        </nav>
        <h1 className="mt-6 text-3xl font-black text-slate-900 sm:text-4xl">공지사항</h1>
        <p className="mt-4 text-sm leading-7 text-slate-600">
          운영 공지·배포 소식을 이곳에 게시할 예정이에요. 현재는 준비 중입니다. 급한 문의는{' '}
          <Link to="/inquiry" className="font-semibold text-brand-navy hover:underline">
            공개 문의
          </Link>
          또는 로그인 후 고객문의를 이용해 주세요.
        </p>
        <div className="mt-12 rounded-2xl border border-dashed border-slate-200 bg-slate-50 py-16 text-center text-sm text-slate-500">등록된 공지가 없습니다.</div>
      </div>
    </MarketingSiteLayout>
  )
}
